import '../styles/Profile.css'



function Profile() {
    return (
     <div id='profile'>
      <div id='contenair-profile'>
       <h1>à propos de moi</h1>
       <div>Je m’appelle Elliot Guiberteau, je suis passionné par l’informatique et je me suis spécialisé en systèmes et réseaux. Après l’obtention d’un BAC STI2D, j’ai poursuivi mes études avec un BTS Services Informatiques aux Organisations à IRIS Strasbourg.
        <br></br> 
        <br></br>
        Souhaitant approfondir mes compétences techniques, j’ai ensuite suivi une POEI Administrateur Support, puis obtenu en septembre le Titre Professionnel de Technicien Supérieur Systèmes et Réseaux (TSSR) à Pardawan Strasbourg. Ces formations m’ont permis de développer des compétences solides en administration Linux, gestion d’infrastructures, sécurité, support utilisateurs et automatisation.
        <br></br>
        <br></br>
        Sur le plan professionnel, j’ai acquis de l’expérience à travers plusieurs stages en informatique (développement et systèmes), ainsi qu’une alternance en tant que Technicien Supérieur Systèmes et Réseaux, où j’ai travaillé sur l’assistance utilisateurs, la maintenance et l’administration de systèmes et réseaux. J’ai également occupé différents emplois saisonniers, qui ont renforcé mon sens de l’organisation, mon autonomie et mon esprit d’équipe.
         </div>
       </div>
     </div>
    )
}


export default Profile

